module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAUCAYAAAB8gkaAAAAAPElEQVRIx2NkmJfwn4FOgHHUslHL8FpWsNX+GN0s+3NR7P+oZaOWDQ7LwptX0S/pW5Ue+T9q2ahlg8IyALSQMG8eIBpVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ga.png
// module id = 826
// module chunks = 0